import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const requestSchema = z.object({
	EncryptedPolicyId: z.string(),
	MemberId: z.string(),
	Type: z.string(),
	File: z.string(),
});

export const responseSchema = z.object({
	fileUrl: z.string(),
	lastUpdatedOn: z.string(),
});

const postPolicyUploadDocument = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: 'admin/policy/document/member/upload',
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		errorCodes: ['FileIsAlreadyUploadedBefore'],
		method: 'POST',
		responseSchema,
		requestSchema,
	});

export type postPolicyUploadDocumentRequest = z.infer<typeof requestSchema>;

export type postPolicyUploadDocumentResponse = TypeOfAPIResponse<ReturnType<typeof postPolicyUploadDocument>>;

export type postPolicyUploadDocumentError = TypeOfAPIError<ReturnType<typeof postPolicyUploadDocument>>;

export default postPolicyUploadDocument;
